module.exports = __webpack_public_path__ + "static/brillea_dashboard_resultsDetail-8043725020c9e876b7d1d086d6441149.png";